import { IProjectData, projectStore, IProject } from "@droid/project-v2-interface"
import { loadI18nValue, watchUpdates } from "@fanfanlo"
import { Box, List, ListItem } from "@mui/material"
import { use, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { CreateProjectButton } from "../components/CreateProjectButton"
import { ProjectUI } from "../project/ProjectUI"
function ProjectsTitle() {
    const { t } = useTranslation('droid-project/project/ui/projects/content')
    // const v = use(loadI18nValue('droid-project/project/ui/projects/content', 'content.projects'))
    // console.log('ttttttttttttttttttttttt', v, 'tttt', t)
    return <div>
        <h4>{t('content.projects')}</h4>
        {/* <h4>{v}</h4> */}
    </div>
}

function ProjectList({ projects }: { projects: IProject[] }) {
    return (
        <List sx={{width:"100%"}}>
            {projects.length > 0 && projects.map((project) => (
                <ListItem sx={{width:"100%"}} key={project.ulid}>
                    <ProjectUI key={project.ulid} project={project} />
                </ListItem>
            ))}
        </List>
    )
}
function Projects() {
    const { t } = useTranslation('droid-project/project/ui/projects/content')

    const [projects, setProjects] = useState<IProject[]>(projectStore.getListCopy())
    useEffect(() => {
        const unsub = watchUpdates(projectStore.list, () => {
            setProjects(projectStore.getListCopy())
        })
        return () => {
            unsub()
        }
    }, [])
    return <Box>
        <CreateProjectButton />
        {projects.length == 0 && <Box>
            <Box>
                <span>{t('content.noProjects')}</span>
                {/* <CreateProjectButton /> */}
                <span>{t('content.orFindFromMarket')}</span>
            </Box>
        </Box>}
        {projects.length > 0 && <ProjectList projects={projects} />}
    </Box>
}

export function ProjectsUI() {
    return (<Box>
        <ProjectsTitle />
        <Projects />
    </Box>)
}
